module.exports = __webpack_public_path__ + "img/feature-icon-3.ca894311.svg";